import { Show } from "solid-js";
import type { IconName } from "../icon/Icon";
import { Icon } from "../icon/Icon";
import { useTranslation } from "../../state/i18n";
import type { ClassList } from "../../types";
import Text from "../text/Text";

type ClosablePillProps = {
  onClick: () => void;
  label: string;
  icon?: IconName;
  variant: "neutral" | "destructive";
  classList?: ClassList;
};

const ClosablePill = (props: ClosablePillProps) => {
  const { t } = useTranslation();

  return (
    <button
      aria-label={t(($) => $.PILL_REMOVE_ARIA_LABEL, { value: props.label })}
      title={t(($) => $.PILL_REMOVE_ARIA_LABEL, { value: props.label })}
      onClick={() => props.onClick()}
      class="inline-flex h-4 max-w-43.5 items-center gap-0.5 rounded-sm p-1 text-small-medium focus-visible:outline-default"
      classList={{
        ...props.classList,
        "bg-surface-subtle text-primary hover:bg-surface-subtle-hover": props.variant === "neutral",
        "bg-surface-destructive text-status-danger hover:bg-surface-destructive-hover": props.variant === "destructive",
      }}
    >
      <Show when={props.icon}>{(icon) => <Icon name={icon()} type="solid" size="xs" class="shrink-0" />}</Show>
      <Text
        as="span"
        truncate
        text={props.label}
        class="text-small-medium"
        classList={{
          "icon-status-danger": props.variant === "destructive",
          "icon-primary": props.variant === "neutral",
        }}
      />
      <Icon name="x" type="solid" size="xs" class="shrink-0 icon-primary" />
    </button>
  );
};

export default ClosablePill;
